var _g, _line, _line2, _line3, _line4, _line5, _line6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4 1.625C0.4 0.948457 0.948448 0.4 1.62498 0.4C2.3015 0.4 2.84995 0.948457 2.84995 1.625C2.84995 2.30154 2.3015 2.85 1.62498 2.85C0.948448 2.85 0.4 2.30154 0.4 1.625Z",
    stroke: "#CDCDCD",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4 8.01855C0.4 7.34201 0.948449 6.79355 1.62498 6.79355C2.30151 6.79355 2.84996 7.34201 2.84996 8.01855C2.84996 8.6951 2.30151 9.24355 1.62498 9.24355C0.948449 9.24355 0.4 8.6951 0.4 8.01855Z",
    stroke: "#CDCDCD",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4 14.4121C0.4 13.7356 0.948449 13.1871 1.62498 13.1871C2.30151 13.1871 2.84996 13.7356 2.84996 14.4121C2.84996 15.0887 2.30151 15.6371 1.62498 15.6371C0.948449 15.6371 0.4 15.0887 0.4 14.4121Z",
    stroke: "#CDCDCD",
    strokeWidth: 0.8
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 1.6252,
    x2: 17.9998,
    y2: 1.6252,
    stroke: "#A4A4A4",
    strokeWidth: 1.0123
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 1.6252,
    x2: 17.9998,
    y2: 1.6252,
    stroke: "#A4A4A4",
    strokeWidth: 1.0123
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 8.01827,
    x2: 17.9998,
    y2: 8.01827,
    stroke: "#A4A4A4",
    strokeWidth: 1.0123
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 8.01827,
    x2: 17.9998,
    y2: 8.01827,
    stroke: "#A4A4A4",
    strokeWidth: 1.0123
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 14.4118,
    x2: 17.9998,
    y2: 14.4118,
    stroke: "#A4A4A4",
    strokeWidth: 1.0123
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 14.4118,
    x2: 17.9998,
    y2: 14.4118,
    stroke: "#A4A4A4",
    strokeWidth: 1.0123
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.5168064c2bbbf0b5961f2c4c2e7318ab.svg";
export { ForwardRef as ReactComponent };